import "./es.array.concat-d1c9b847.js";
import "./es.array.from-fe752fa6.js";
import "./es.array.is-array-7a29277f.js";
import "./es.array.map-d821aaf5.js";
import "./es.date.to-string-6ed49878.js";
import "./es.object.assign-7e79fd7b.js";
import "./es.object.to-string-f55666a8.js";
import "./es.regexp.to-string-e800d529.js";
import "./es.string.iterator-5de8a61e.js";
import "./es.string.trim-6e13db75.js";
import { useTheme as Le } from "@ucl/shared-component-foundations";
import { useCustomTranslation as Ie } from "@ucl/ucl-translation";
import { useState as ie, useRef as z, useCallback as We, useEffect as oe } from "react";
import b from "styled-components";
import "./es.array.filter-4e9c9996.js";
import "./es.object.from-entries-0d7a0e54.js";
import "./es.object.entries-d2a19275.js";
import "./es.string.replace-f4cc3aea.js";
import "./web.dom-collections.for-each-3020ed11.js";
import { g as xe } from "./getMetrics-953aa4f8.js";
import { HelperText as Re } from "./helperText.js";
import { Tooltip as ae } from "./tooltip.js";
import { jsxs as C, jsx as p, Fragment as le } from "react/jsx-runtime";
import "./export-cdcbfb2b.js";
import "./create-property-f9780ed1.js";
import "./object-create-9b6715a2.js";
import "./object-keys-719a5561.js";
import "./html-32ef1b46.js";
import "./correct-is-regexp-logic-4465cd47.js";
import "./is-regexp-4c49b1c2.js";
import "./to-string-92a62764.js";
import "./classof-21a3574e.js";
import "./array-iteration-759bfbfa.js";
import "./iterate-13ada9e5.js";
import "./check-correctness-of-iteration-7d57c70c.js";
import "./function-uncurry-this-clause-99074d1c.js";
import "./string-trim-14e37ad3.js";
import "./object-to-array-0474b7e7.js";
import "./object-set-prototype-of-7d7e5736.js";
import "./function-apply-4756dee6.js";
import "./array-method-is-strict-e5a3c878.js";
import "./index-8b07dec9.js";
import "./index-5d0f31c6.js";
import "./objectWithoutPropertiesLoose-2ffc4b6d.js";
import "./es.object.keys-9d66766f.js";
import "./object-get-own-property-names-external-2f8b4cc4.js";
import "./array-slice-79f93c56.js";
import "./an-instance-6efcfd6c.js";
import "./inherit-if-required-f068457b.js";
import "./define-built-in-accessor-26bc7b69.js";
import "./set-species-5ede2ed0.js";
import "@ucl/shared-icons";
import "./web.set-timeout-72b6430f.js";
import "./environment-ddee5959.js";
import "./validate-arguments-length-eb516e5b.js";
import "react-dom";
import "./usePopoverIndex.js";
import "./useEventListener.js";
import "./getTarget-19e0f923.js";
import "./isClient-2f5bedbd.js";
import "./es.array.some-0c761b6d.js";
import "./es.array.every-3d11adb5.js";
import "./useScroll.js";
import "./useOverFlown.js";
import "./useResizeObserver.js";
import "./isApiSupported-66660265.js";
import "./useIsMounted.js";
import "./useSlots.js";
import "./createClass-57dcdeea.js";
import "./es.date.to-json-b76d522e.js";
import "./useWindowSize.js";
import "./es.array.join-c1bca812.js";
import "./es.parse-float-020a2ae0.js";
import "./es.regexp.constructor-6da4b85c.js";
import "./uniqueId.js";
import "./es.global-this-a7f40ce1.js";
import "./getElementPosition-8d0dbc61.js";
import "./es.parse-int-d7709701.js";
import "./es.string.starts-with-a6645e0a.js";
var K = ["ArrowDown", "ArrowUp", "ArrowLeft", "ArrowRight"], _ = ["ArrowUp", "ArrowRight"], ze = ["ArrowLeft", "ArrowDown"], De = /* @__PURE__ */ b.div.withConfig({
  displayName: "slider__SliderContainer",
  componentId: "zwk5yg-0"
})(["display:", ";flex-direction:", ";align-items:", ";box-sizing:", ";justify-content:", ";width:", ";position:", ";.thumb,.thumb::-webkit-slider-thumb{-webkit-appearance:", ";-webkit-tap-highlight-color:", ";}.thumb{pointer-events:", ";position:", ";height:", ";width:", ";outline:", ";}.thumb::-webkit-slider-thumb{background-color:", ";border:", ";border-radius:", ";", ";height:", ";width:", ";margin-top:", ";pointer-events:", ";position:", ";&:hover{background-color:", ";}&:active{background-color:", ";}}.thumb:focus-visible::-webkit-slider-thumb{outline:", ";outline-offset:", ";}input:disabled{&.thumb::-webkit-slider-thumb{background-color:", ";border:", ";&:hover{background-color:", ";pointer:", ";}}}.thumb::-moz-range-thumb{background-color:", ";border:", ";border-radius:", ";cursor:", ";height:", ";width:", ";margin-top:", ";pointer-events:", ";position:", ";&:hover{background-color:", ";}&:active{background-color:", ";}}"], function(e) {
  return e.theme.components.slider.SliderContainer.display;
}, function(e) {
  return e.theme.components.slider.SliderContainer.flexDirection;
}, function(e) {
  return e.theme.components.slider.SliderContainer.alignItems;
}, function(e) {
  return e.theme.components.slider.SliderContainer.boxSizing;
}, function(e) {
  return e.theme.components.slider.SliderContainer.justifyContent;
}, function(e) {
  return e.theme.components.slider.SliderContainer.width;
}, function(e) {
  return e.theme.components.slider.SliderContainer.position;
}, function(e) {
  return e.theme.components.slider.SliderContainer.thumbWebkitSliderThumb["-webkit-appearance"];
}, function(e) {
  return e.theme.components.slider.SliderContainer.thumbWebkitSliderThumb["-webkit-tap-highlight-color"];
}, function(e) {
  return e.theme.components.slider.SliderContainer.thumb.pointerEvents;
}, function(e) {
  return e.theme.components.slider.SliderContainer.thumb.position;
}, function(e) {
  return e.theme.components.slider.SliderContainer.thumb.height;
}, function(e) {
  return e.theme.components.slider.SliderContainer.thumb.width;
}, function(e) {
  return e.theme.components.slider.SliderContainer.thumb.outline;
}, function(e) {
  return e.theme.components.slider.SliderContainer.webkitSliderThumb.backgroundColor;
}, function(e) {
  return e.theme.components.slider.SliderContainer.webkitSliderThumb.border;
}, function(e) {
  return e.theme.components.slider.SliderContainer.webkitSliderThumb.borderRadius;
}, function(e) {
  return !e.isDisabled && "cursor: " + e.theme.components.slider.SliderContainer.webkitSliderThumb.cursor.default;
}, function(e) {
  return e.theme.components.slider.SliderContainer.webkitSliderThumb.height;
}, function(e) {
  return e.theme.components.slider.SliderContainer.webkitSliderThumb.width;
}, function(e) {
  return e.theme.components.slider.SliderContainer.webkitSliderThumb.marginTop;
}, function(e) {
  return e.theme.components.slider.SliderContainer.webkitSliderThumb.pointerEvents;
}, function(e) {
  return e.theme.components.slider.SliderContainer.webkitSliderThumb.position;
}, function(e) {
  return e.theme.components.slider.SliderContainer.webkitSliderThumb.hover.backgroundColor;
}, function(e) {
  return e.theme.components.slider.SliderContainer.webkitSliderThumb.active.backgroundColor;
}, function(e) {
  return e.theme.components.slider.SliderContainer.thumbFocusVisibleWebkitSliderThumb.outline;
}, function(e) {
  return e.theme.components.slider.SliderContainer.thumbFocusVisibleWebkitSliderThumb.outlineOffset;
}, function(e) {
  return e.theme.components.slider.SliderContainer.inputDisabled.thumbWebkitSliderThumb.backgroundColor;
}, function(e) {
  return e.theme.components.slider.SliderContainer.inputDisabled.thumbWebkitSliderThumb.border;
}, function(e) {
  return e.theme.components.slider.SliderContainer.inputDisabled.thumbWebkitSliderThumb.hover.backgroundColor;
}, function(e) {
  return e.theme.components.slider.SliderContainer.inputDisabled.thumbWebkitSliderThumb.hover.pointer;
}, function(e) {
  return e.theme.components.slider.SliderContainer.thumbMozRangeThumb.backgroundColor;
}, function(e) {
  return e.theme.components.slider.SliderContainer.thumbMozRangeThumb.border;
}, function(e) {
  return e.theme.components.slider.SliderContainer.thumbMozRangeThumb.borderRadius;
}, function(e) {
  return e.theme.components.slider.SliderContainer.thumbMozRangeThumb.cursor;
}, function(e) {
  return e.theme.components.slider.SliderContainer.thumbMozRangeThumb.height;
}, function(e) {
  return e.theme.components.slider.SliderContainer.thumbMozRangeThumb.width;
}, function(e) {
  return e.theme.components.slider.SliderContainer.thumbMozRangeThumb.marginTop;
}, function(e) {
  return e.theme.components.slider.SliderContainer.thumbMozRangeThumb.pointerEvents;
}, function(e) {
  return e.theme.components.slider.SliderContainer.thumbMozRangeThumb.position;
}, function(e) {
  return e.theme.components.slider.SliderContainer.thumbMozRangeThumb.hover.backgroundColor;
}, function(e) {
  return e.theme.components.slider.SliderContainer.thumbMozRangeThumb.active.backgroundColor;
}), $ = /* @__PURE__ */ b.input.withConfig({
  displayName: "slider__SliderInput",
  componentId: "zwk5yg-1"
})(["z-index:", ";", ";margin-left:", ";"], function(e) {
  return e.inputType === "first" ? e.theme.components.slider.SliderInput.zIndex.inputTypeFirst : e.theme.components.slider.SliderInput.zIndex.default;
}, function(e) {
  return e.inputType === "first" && !Array.isArray(e.sliderValue) && "display: " + e.theme.components.slider.SliderInput.display;
}, function(e) {
  return e.inputType === "first" ? e.theme.components.slider.SliderInput.marginLeft.inputTypeFirst : e.theme.components.slider.SliderInput.marginLeft.default;
}), Ve = /* @__PURE__ */ b.div.withConfig({
  displayName: "slider__SliderWrapper",
  componentId: "zwk5yg-2"
})(["position:", ";width:", ";margin:", ";.tooltip-left{width:", ";position:", ";div[role='tooltip']{left:", ";bottom:", ";}}.tooltip-right{width:", ";position:", ";div[role='tooltip']{left:", ";bottom:", ";}}"], function(e) {
  return e.theme.components.slider.SliderWrapper.position;
}, function(e) {
  return e.theme.components.slider.SliderWrapper.width;
}, function(e) {
  return e.theme.components.slider.SliderWrapper.margin;
}, function(e) {
  return e.theme.components.slider.SliderWrapper.tooltipLeft.width;
}, function(e) {
  return e.theme.components.slider.SliderWrapper.tooltipLeft.position;
}, function(e) {
  var w = e.$minValue, i = e.$max, L = e.$min, u = e.$getPercent, v = u(w);
  return w < (L + i) / 2 ? "calc(1% + " + v + "%)" : "calc(-1% + " + v + "%)";
}, function(e) {
  return e.theme.components.slider.SliderWrapper.tooltipLeft.divRoleTooltip.bottom;
}, function(e) {
  return e.theme.components.slider.SliderWrapper.tooltipRight.width;
}, function(e) {
  return e.theme.components.slider.SliderWrapper.tooltipRight.position;
}, function(e) {
  var w = e.$maxValue, i = e.$max, L = e.$min, u = e.$getPercent, v = u(w);
  return w < (L + i) / 2 ? "calc(1% + " + v + "%)" : "calc(-1% + " + v + "%)";
}, function(e) {
  return e.theme.components.slider.SliderWrapper.tooltipRight.divRoleTooltip.bottom;
}), Ne = /* @__PURE__ */ b.div.withConfig({
  displayName: "slider__SliderTrack",
  componentId: "zwk5yg-3"
})(["background-color:", ";border-radius:", ";height:", ";width:", ";position:", ";z-index:", ";width:", ";"], function(e) {
  return e.isDisabled ? e.theme.components.slider.SliderTrack.backgroundColor.disabled : e.theme.components.slider.SliderTrack.backgroundColor.default;
}, function(e) {
  return e.theme.components.slider.SliderTrack.borderRadius;
}, function(e) {
  return e.theme.components.slider.SliderTrack.height;
}, function(e) {
  return e.theme.components.slider.SliderTrack.width;
}, function(e) {
  return e.theme.components.slider.SliderTrack.position;
}, function(e) {
  return e.theme.components.slider.SliderTrack.zIndex;
}, function(e) {
  return e.theme.components.slider.SliderTrack.width;
}), Me = /* @__PURE__ */ b.div.withConfig({
  displayName: "slider__SliderRange",
  componentId: "zwk5yg-4"
})(["background-color:", ";border-radius:", ";height:", ";position:", ";z-index:", ";"], function(e) {
  return e.isDisabled ? e.theme.components.slider.SliderRange.backgroundColor.disabled : e.theme.components.slider.SliderRange.backgroundColor.default;
}, function(e) {
  return e.theme.components.slider.SliderRange.borderRadius;
}, function(e) {
  return e.theme.components.slider.SliderRange.height;
}, function(e) {
  return e.theme.components.slider.SliderRange.position;
}, function(e) {
  return e.theme.components.slider.SliderRange.zIndex;
}), ue = /* @__PURE__ */ b.div.withConfig({
  displayName: "slider__InputContainer",
  componentId: "zwk5yg-5"
})(["display:", ";box-sizing:", ";border-radius:", ";border:", ";background:", ";width:", ";padding:", ";align-items:", ";justify-content:", ";margin:", ";&.input-focus{border:", ";margin:", ";}"], function(e) {
  return e.theme.components.slider.InputContainer.display;
}, function(e) {
  return e.theme.components.slider.InputContainer.boxSizing;
}, function(e) {
  return e.theme.components.slider.InputContainer.borderRadius;
}, function(e) {
  return e.theme.components.slider.InputContainer.border;
}, function(e) {
  return e.isDisabled ? e.theme.components.slider.InputContainer.background.disabled : e.theme.components.slider.InputContainer.background.default;
}, function(e) {
  return e.theme.components.slider.InputContainer.width;
}, function(e) {
  return e.theme.components.slider.InputContainer.padding;
}, function(e) {
  return e.theme.components.slider.InputContainer.alignItems;
}, function(e) {
  return e.theme.components.slider.InputContainer.justifyContent;
}, function(e) {
  return e.theme.components.slider.InputContainer.margin;
}, function(e) {
  return e.theme.components.slider.InputContainer.inputFocus.border;
}, function(e) {
  return e.theme.components.slider.InputContainer.inputFocus.margin;
}), Be = /* @__PURE__ */ b.div.withConfig({
  displayName: "slider__LabelWrapper",
  componentId: "zwk5yg-6"
})(["display:", ";flex-direction:", ";justify-content:", ";width:", ";margin-bottom:", ";font-family:", ";font-size:", ";font-style:", ";font-weight:", ";line-height:", ";color:", ";", ";"], function(e) {
  return e.theme.components.slider.LabelWrapper.display;
}, function(e) {
  return Array.isArray(e.value) && e.category === "inputField" ? e.theme.components.slider.LabelWrapper.flexDirection.categoryInputField : e.theme.components.slider.LabelWrapper.flexDirection.default;
}, function(e) {
  return e.theme.components.slider.LabelWrapper.justifyContent;
}, function(e) {
  return e.theme.components.slider.LabelWrapper.width;
}, function(e) {
  return e.theme.components.slider.LabelWrapper.marginBottom;
}, function(e) {
  return e.theme.components.slider.LabelWrapper.fontFamily;
}, function(e) {
  return e.theme.components.slider.LabelWrapper.fontSize;
}, function(e) {
  return e.theme.components.slider.LabelWrapper.fontStyle;
}, function(e) {
  return e.theme.components.slider.LabelWrapper.fontWeight;
}, function(e) {
  return e.theme.components.slider.LabelWrapper.lineHeight;
}, function(e) {
  return e.theme.components.slider.LabelWrapper.color;
}, function(e) {
  return !Array.isArray(e.value) && "align-items: " + e.theme.components.slider.LabelWrapper.alignItems;
}), Ke = /* @__PURE__ */ b.div.withConfig({
  displayName: "slider__ValueLabelWrapper",
  componentId: "zwk5yg-7"
})(["display:", ";justify-content:", ";width:", ";font-family:", ";font-size:", ";font-style:", ";font-weight:", ";line-height:", ";color:", ";", ";padding:", ";"], function(e) {
  return e.theme.components.slider.ValueLabelWrapper.display;
}, function(e) {
  return e.theme.components.slider.ValueLabelWrapper.justifyContent;
}, function(e) {
  return e.theme.components.slider.ValueLabelWrapper.width;
}, function(e) {
  return e.theme.components.slider.ValueLabelWrapper.fontFamily;
}, function(e) {
  return e.theme.components.slider.ValueLabelWrapper.fontSize;
}, function(e) {
  return e.theme.components.slider.ValueLabelWrapper.fontStyle;
}, function(e) {
  return e.theme.components.slider.ValueLabelWrapper.fontWeight;
}, function(e) {
  return e.theme.components.slider.ValueLabelWrapper.lineHeight;
}, function(e) {
  return e.isDisabled ? e.theme.components.slider.ValueLabelWrapper.color.disabled : e.theme.components.slider.ValueLabelWrapper.color.default;
}, function(e) {
  return !e.isDiscrete && "margin-top : " + e.theme.components.slider.ValueLabelWrapper.marginTop + ";";
}, function(e) {
  return e.theme.components.slider.ValueLabelWrapper.padding;
}), se = /* @__PURE__ */ b.div.withConfig({
  displayName: "slider__ValueLabel",
  componentId: "zwk5yg-8"
})([""]), $e = /* @__PURE__ */ b.div.withConfig({
  displayName: "slider__InputWrapper",
  componentId: "zwk5yg-9"
})(["display:", ";justify-content:", ";"], function(e) {
  return e.theme.components.slider.InputWrapper.display;
}, function(e) {
  return e.theme.components.slider.InputWrapper.justifyContent;
}), Fe = /* @__PURE__ */ b.span.withConfig({
  displayName: "slider__DiscreteTick",
  componentId: "zwk5yg-10"
})(["width:", ";height:", ";background:", ";border-radius:", ";"], function(e) {
  return e.theme.components.slider.DiscreteTick.width;
}, function(e) {
  return e.theme.components.slider.DiscreteTick.height;
}, function(e) {
  return e.isDisabled ? e.theme.components.slider.DiscreteTick.background.disabled : e.theme.components.slider.DiscreteTick.background.default;
}, function(e) {
  return e.theme.components.slider.DiscreteTick.borderRadius;
}), Pe = /* @__PURE__ */ b.div.withConfig({
  displayName: "slider__TricksWrapper",
  componentId: "zwk5yg-11"
})(["display:", ";justify-content:", ";width:", ";margin-bottom:", ";margin-left:", ";margin-top:", ";"], function(e) {
  return e.theme.components.slider.TricksWrapper.display;
}, function(e) {
  return e.theme.components.slider.TricksWrapper.justifyContent;
}, function(e) {
  return e.theme.components.slider.TricksWrapper.width;
}, function(e) {
  return e.theme.components.slider.TricksWrapper.marginBottom;
}, function(e) {
  return e.theme.components.slider.TricksWrapper.marginLeft;
}, function(e) {
  return e.theme.components.slider.TricksWrapper.marginTop;
}), je = /* @__PURE__ */ b.div.withConfig({
  displayName: "slider__Label",
  componentId: "zwk5yg-12"
})(["", ";font-family:", ";font-size:", ";font-style:", ";font-weight:", ";line-height:", ";color:", ";"], function(e) {
  return Array.isArray(e.value) && e.category === "inputField" && "margin-bottom: " + e.theme.components.slider.Label.marginBottom + ";";
}, function(e) {
  return e.theme.components.slider.Label.fontFamily;
}, function(e) {
  return e.theme.components.slider.Label.fontSize;
}, function(e) {
  return e.theme.components.slider.Label.fontStyle;
}, function(e) {
  return e.theme.components.slider.Label.fontWeight;
}, function(e) {
  return e.theme.components.slider.Label.lineHeight;
}, function(e) {
  return e.theme.components.slider.Label.color;
}), Ee = /* @__PURE__ */ b.div.withConfig({
  displayName: "slider__RangeLabel",
  componentId: "zwk5yg-13"
})(["", ";font-family:", ";font-size:", ";font-style:", ";font-weight:", ";line-height:", ";color:", ";"], function(e) {
  return Array.isArray(e.value) && e.category === "inputField" && "margin-bottom: " + e.theme.components.slider.RangeLabel.marginBottom + ";";
}, function(e) {
  return e.theme.components.slider.RangeLabel.fontFamily;
}, function(e) {
  return e.theme.components.slider.RangeLabel.fontSize;
}, function(e) {
  return e.theme.components.slider.RangeLabel.fontStyle;
}, function(e) {
  return e.theme.components.slider.RangeLabel.fontWeight;
}, function(e) {
  return e.theme.components.slider.RangeLabel.lineHeight;
}, function(e) {
  return e.isDisabled ? e.theme.components.slider.RangeLabel.color.disabled : e.theme.components.slider.RangeLabel.color.default;
}), de = /* @__PURE__ */ b.input.withConfig({
  displayName: "slider__BaseTextInput",
  componentId: "zwk5yg-14"
})(["width:", ";letter-spacing:", ";font-size:", ";background-color:", ";color:", ";border-style:", ";outline-style:", ";font-style:", ";font-weight:", ";line-height:", ";"], function(e) {
  return e.theme.components.slider.BaseTextInput.width;
}, function(e) {
  return e.theme.components.slider.BaseTextInput.letterSpacing;
}, function(e) {
  return e.theme.components.slider.BaseTextInput.fontSize;
}, function(e) {
  return e.theme.components.slider.BaseTextInput.backgroundColor;
}, function(e) {
  return e.disabled ? e.theme.components.slider.BaseTextInput.color.disabled : e.theme.components.slider.BaseTextInput.color.default;
}, function(e) {
  return e.theme.components.slider.BaseTextInput.borderStyle;
}, function(e) {
  return e.theme.components.slider.BaseTextInput.outlineStyle;
}, function(e) {
  return e.theme.components.slider.BaseTextInput.fontStyle;
}, function(e) {
  return e.theme.components.slider.BaseTextInput.fontWeight;
}, function(e) {
  return e.theme.components.slider.BaseTextInput.lineHeight;
}), _e = /* @__PURE__ */ b.div.withConfig({
  displayName: "slider__StyledSlider",
  componentId: "zwk5yg-15"
})(["display:", ";flex-direction:", ";gap:", ";"], function(e) {
  return e.theme.components.slider.StyledSlider.display;
}, function(e) {
  return e.theme.components.slider.StyledSlider.flexDirection;
}, function(e) {
  return e.theme.components.slider.StyledSlider.gap;
});
function bn(e) {
  var w = e.min, i = w === void 0 ? 0 : w, L = e.max, u = L === void 0 ? 100 : L, v = e.isDiscrete, s = v === void 0 ? !1 : v, q = e.steps, A = q === void 0 ? 10 : q, H = e.category, I = H === void 0 ? "tooltip" : H, O = e.label, d = e.onChange, U = e.isDisabled, f = U === void 0 ? !1 : U, n = e.value, G = e.isRequired, F = G === void 0 ? !1 : G, J = e.showRequiredIndicator, me = J === void 0 ? F : J, D = e.helperTextProp, ce = e.inputState, P = e.valueLabel, Q = e.minLabel, pe = Q === void 0 ? i.toString() : Q, X = e.maxLabel, he = X === void 0 ? u.toString() : X, fe = xe({
    label: "Slider"
  }), be = Ie("Slider"), R = be.t, m = function(r) {
    var t = (u - i) / A, a = i;
    if (r < i)
      return i;
    if (r > u)
      return u;
    for (var o = 0; o < A; o++) {
      var c = a;
      if (a = a + t, r <= a)
        return r < c + t / 2 ? c : a;
    }
    return a;
  }, j = Array.isArray(n) ? s ? m(n[0]) : n[0] : 0, E = Array.isArray(n) ? s ? m(n[1]) : n[1] : n, Y = ie(j), y = Y[0], S = Y[1], Z = ie(E), h = Z[0], g = Z[1], V = z(null), N = z(null), W = z(null), k = z(null), T = z(null), ge = Le(), ye = Array.from(Array(A + 1), function(l, r) {
    return r + 1;
  }), x = We(function(l) {
    return Math.round((l - i) / (u - i) * 100);
  }, [i, u]), Se = function(r) {
    r[1] > u && d(null, [r[0], u]), r[0] < i && d(null, [i, r[1]]), r[1] < r[0] && d(null, [r[0], r[0]]), r[0] > r[1] && d(null, [r[1], r[1]]);
  }, Ce = function(r) {
    if (N.current && Array.isArray(r) && r[0] >= 0) {
      var t = Array.isArray(r) ? s ? m(r[0]) : r[0] : i, a = x(t), o = x(+N.current.value);
      W.current && (W.current.style.left = a + "%", W.current.style.width = o - a + "%", S(s ? m(r[0]) : r[0]));
    }
  }, we = function(r) {
    if (V.current && (Array.isArray(r) ? r[1] >= 0 : r >= 0)) {
      var t = x(+V.current.value), a = Array.isArray(r) ? s ? m(r[1]) : r[1] : r, o = x(a);
      W.current && (W.current.style.width = o - t + "%", Array.isArray(r) ? g(r[1]) : g(r));
    }
  };
  oe(function() {
    var l = !Array.isArray(n) && (n < i || n > u);
    if (l)
      n < i && d(null, i), n > u && d(null, u);
    else {
      var r = Array.isArray(n) && (n[1] < n[0] || n[0] > n[1] || n[0] < i || n[1] > u);
      r ? Se(n) : (Ce(n), we(n));
    }
  }, [n, x, i, u, s, A]), oe(function() {
    s && Array.isArray(n) && (j !== n[0] || E !== n[1]) && d(null, [j, E]);
  }, []);
  var ve = function(r) {
    if (r.target.value === "-" || r.target.value === "") {
      var t = r.target.value;
      g(t);
    } else
      isNaN(+r.target.value) || g(+r.target.value);
  }, Ae = function(r) {
    if (r.target.value === "-" || r.target.value === "") {
      var t = r.target.value;
      S(t);
    } else
      isNaN(+r.target.value) || S(+r.target.value);
  }, ee = function(r) {
    if (y === "" || y === "-")
      S(Array.isArray(n) ? n[0] : i);
    else if (typeof y == "number" && Array.isArray(n))
      if (y > n[1] || y < i) {
        var t = y > n[1] ? n[1] : y < i ? i : n[0], a = [].concat(n);
        a[0] = t, d(r, a), S(t);
      } else if (s) {
        var o = m(y);
        d(r, [o, n[1]]), S(m(n[0]));
      } else
        d(r, [y, n[1]]);
  }, re = function(r) {
    if (h === "" || h === "-")
      g(Array.isArray(n) ? n[1] : n);
    else if (typeof h == "number" && Array.isArray(n))
      if (h < n[0] || h > u) {
        var t = h < n[0] ? n[0] : u;
        d(r, [n[0], t]), g(t);
      } else
        s ? (d(r, [n[0], m(h)]), g(m(h))) : d(r, [n[0], h]);
    else if (typeof h == "number" && !Array.isArray(n))
      if (h < i || h > u) {
        var a = h < i ? i : u;
        d(r, a), g(a);
      } else
        s ? (d(r, m(h)), g(m(h))) : d(r, h);
  }, ne = function(r) {
    return !(!isNaN(r) && Math.abs(r % 1) === 0 || r === "-");
  }, M = function(r, t, a, o) {
    var c = o === "min" ? t[0] : t[1];
    if (c = _.includes(r.code) ? c + a : c - a, !(c < i || c > u))
      if (o === "min") {
        if (t[0] === t[1] && _.includes(r.code))
          return;
        d(r, [c, t[1]]), S(c);
      } else {
        if (t[0] === t[1] && ze.includes(r.code))
          return;
        d(r, [t[0], c]), g(c);
      }
  }, B = function(r, t, a) {
    var o = t;
    o = _.includes(r.code) ? o + a : o - a, !(o < i || o > u) && (d(r, o), g(o));
  }, ke = function(r, t, a) {
    if (s) {
      var o = m(r);
      o !== a[1] && d(t, [a[0], o]), g(o);
    } else
      d(t, [a[0], r]), g(r);
  }, Te = function(r, t, a) {
    if (s) {
      var o = m(r);
      o !== a && d(t, o), g(o);
    } else
      d(t, r), g(r);
  };
  return /* @__PURE__ */ C(_e, Object.assign({}, fe, {
    children: [/* @__PURE__ */ C(De, {
      isDisabled: f,
      children: [/* @__PURE__ */ C(Be, {
        value: n,
        category: I,
        children: [O && /* @__PURE__ */ C(je, {
          value: n,
          category: I,
          children: [O, me && /* @__PURE__ */ C("span", {
            "aria-hidden": "true",
            style: {
              color: ge.components.slider.LabelRequiredIndicatorColor
            },
            children: [" ", "*"]
          })]
        }), I === "inputField" && /* @__PURE__ */ C($e, {
          children: [Array.isArray(n) && /* @__PURE__ */ p(ue, {
            isDisabled: f,
            children: /* @__PURE__ */ p(de, {
              "aria-label": R("Slider min input", "minInputLabel"),
              id: "min-value",
              type: "text",
              "aria-required": F,
              ref: k,
              disabled: f,
              value: y,
              onChange: Ae,
              onKeyPress: function(r) {
                ne(r.key) && r.preventDefault(), (r.code === "Escape" || r.code === "Enter") && ee(r);
              },
              onBlur: function(r) {
                return ee(r);
              }
            })
          }), /* @__PURE__ */ p(ue, {
            isDisabled: f,
            children: /* @__PURE__ */ p(de, {
              "aria-label": R("Slider max input", "maxInputLabel"),
              id: "max-value",
              type: "text",
              "aria-required": F,
              ref: T,
              disabled: f,
              value: h,
              onChange: ve,
              onKeyPress: function(r) {
                ne(r.key) && r.preventDefault(), (r.code === "Escape" || r.code === "Enter") && re(r);
              },
              onBlur: function(r) {
                return re(r);
              }
            })
          })]
        }), I === "tooltip" && /* @__PURE__ */ p(Ee, {
          value: n,
          category: I,
          isDisabled: f,
          children: P != null && P.trim().length ? P : Array.isArray(n) ? s ? m(n[0]) + " - " + m(n[1]) : n[0] + " - " + n[1] : n
        })]
      }), /* @__PURE__ */ C(Ve, {
        $minValue: Array.isArray(n) ? s ? m(n[0]) : n[0] : i,
        $maxValue: Array.isArray(n) ? s ? m(n[1]) : n[1] : n,
        $min: i,
        $max: u,
        $getPercent: x,
        children: [I === "tooltip" ? /* @__PURE__ */ C(le, {
          children: [/* @__PURE__ */ p(ae, {
            placement: "top",
            title: Array.isArray(n) ? s ? m(n[0]).toString() : n[0].toString() : i.toString(),
            className: "tooltip-left",
            isDisabled: f,
            children: /* @__PURE__ */ p($, {
              type: "range",
              min: i,
              max: u,
              disabled: f,
              value: Array.isArray(n) ? s ? m(n[0]) : n[0] : i,
              ref: V,
              onChange: function(r) {
                var t = Array.isArray(n) ? n[1] : n || 100, a = Math.min(+r.target.value, t - 1);
                if (Array.isArray(n))
                  if (s) {
                    var o = m(a);
                    o !== n[0] && d(r, [o, n[1]]);
                  } else
                    d(r, [a, n[1]]);
                r.target.value = n.toString();
              },
              onKeyDown: function(r) {
                if (K.includes(r.code) && s) {
                  var t = (u - i) / A;
                  Array.isArray(n) ? M(r, n, t, "min") : B(r, n, t), r.preventDefault();
                }
              },
              inputType: "first",
              className: "thumb",
              sliderValue: n
            })
          }), /* @__PURE__ */ p(ae, {
            placement: "top",
            title: Array.isArray(n) ? s ? m(n[1]).toString() : n[1].toString() : n.toString(),
            className: "tooltip-right",
            isDisabled: f,
            children: /* @__PURE__ */ p($, {
              type: "range",
              min: i,
              max: u,
              disabled: f,
              value: Array.isArray(n) ? s ? m(n[1]) : n[1] : n,
              ref: N,
              onChange: function(r) {
                var t = Array.isArray(n) ? n[0] : i || 0, a = Array.isArray(n) ? t + 1 : t, o = Math.max(+r.target.value, a);
                if (Array.isArray(n))
                  if (s) {
                    var c = m(o);
                    c !== n[1] && d(r, [n[0], c]);
                  } else
                    d(r, [n[0], o]);
                else if (s) {
                  var te = m(o);
                  te !== n && d(r, te);
                } else
                  d(r, o);
                r.target.value = n.toString();
              },
              onKeyDown: function(r) {
                if (K.includes(r.code) && s) {
                  var t = (u - i) / A;
                  Array.isArray(n) ? M(r, n, t, "max") : B(r, n, t), r.preventDefault();
                }
              },
              "aria-label": R("Slider input", "sliderInputLabel"),
              inputType: "second",
              className: "thumb",
              sliderValue: n
            })
          })]
        }) : /* @__PURE__ */ C(le, {
          children: [/* @__PURE__ */ p($, {
            type: "range",
            min: i,
            max: u,
            disabled: f,
            value: Array.isArray(n) ? s ? m(n[0]) : n[0] : i,
            ref: V,
            onChange: function(r) {
              if (k.current) {
                var t;
                (t = k.current.parentElement) == null || t.classList.add("input-focus");
              }
              var a = Array.isArray(n) ? n[1] : n || 100, o = Math.min(+r.target.value, a - 1);
              if (Array.isArray(n))
                if (s) {
                  var c = m(o);
                  c !== n[0] && d(r, [c, n[1]]), S(c);
                } else
                  d(r, [o, n[1]]), S(o);
              r.target.value = n.toString();
            },
            onMouseOut: function() {
              if (T.current && k.current) {
                var r, t;
                (r = T.current.parentElement) == null || r.classList.remove("input-focus"), (t = k.current.parentElement) == null || t.classList.remove("input-focus");
              }
            },
            onKeyDown: function(r) {
              if (K.includes(r.code) && s) {
                var t = (u - i) / A;
                Array.isArray(n) ? M(r, n, t, "min") : B(r, n, t), r.preventDefault();
              }
            },
            inputType: "first",
            className: "thumb",
            sliderValue: n,
            "aria-label": R("Slider input", "sliderInputLabel")
          }), /* @__PURE__ */ p($, {
            type: "range",
            min: i,
            max: u,
            disabled: f,
            value: Array.isArray(n) ? s ? m(n[1]) : n[1] : n,
            ref: N,
            onChange: function(r) {
              if (T.current) {
                var t;
                (t = T.current.parentElement) == null || t.classList.add("input-focus");
              }
              var a = Array.isArray(n) ? n[0] : i || 0, o = Array.isArray(n) ? a + 1 : a, c = Math.max(+r.target.value, o);
              Array.isArray(n) ? ke(c, r, n) : Te(c, r, n), r.target.value = n.toString();
            },
            onMouseOut: function() {
              if (T.current && k.current || !Array.isArray(n)) {
                var r, t;
                T == null || (r = T.current) == null || (r = r.parentElement) == null || r.classList.remove("input-focus"), k == null || (t = k.current) == null || (t = t.parentElement) == null || t.classList.remove("input-focus");
              }
            },
            onKeyDown: function(r) {
              if (K.includes(r.code) && s) {
                var t = (u - i) / A;
                Array.isArray(n) ? M(r, n, t, "max") : B(r, n, t), r.preventDefault();
              }
            },
            "aria-label": R("Slider input", "sliderInputLabel"),
            inputType: "second",
            className: "thumb",
            sliderValue: n
          })]
        }), /* @__PURE__ */ p(Ne, {
          isDisabled: f
        }), /* @__PURE__ */ p(Me, {
          isDisabled: f,
          ref: W
        })]
      }), s && /* @__PURE__ */ p(Pe, {
        children: ye.map(function(l, r) {
          return l && /* @__PURE__ */ p(Fe, {
            isDisabled: f
          }, r);
        })
      }), /* @__PURE__ */ C(Ke, {
        isDiscrete: s,
        isDisabled: f,
        children: [/* @__PURE__ */ p(se, {
          children: pe
        }), /* @__PURE__ */ p(se, {
          children: he
        })]
      })]
    }), /* @__PURE__ */ p(Re, {
      defaultProp: D == null ? void 0 : D.defaultProp,
      inputState: ce,
      secondaryProp: D == null ? void 0 : D.secondaryProp
    })]
  }));
}
export {
  bn as Slider
};
